export default __webpack_public_path__ + "static/emanuel-b2feb8f692749e6b893deb7439e7b479.png";